export default __webpack_public_path__ + "static/media/menu.9c6cbdca.png";